import React from "react";

const Footer = () => {
  return (
    <footer id="footer" className="section bg-dark text-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 text-center text-lg-start wow fadeInUp">
            <p className="mb-2 mb-lg-0">
              کپی‌رایت © 2026{" "}
              <a className="fw-600" href="/">
                سینا خانجانی
              </a>
              . تمامی حقوق محفوظ است.
            </p>
          </div>
          <div className="col-lg-6 wow fadeInUp">
            <p className="mb-0 text-center text-lg-end">طراحی و توسعه توسط سینا خانجانی</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
